import * as z from "zod/v4";

export const startDomainWarming = {
  name: "startDomainWarming" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ success: z.boolean() }),
};
